<template>
  <div>
    <div class="content">
<!--      <div class="content-main">-->
<!--        <p class="content-title">用户权限</p>-->
<!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">目录权限</p>
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editUserDialog(-1)" size="default">创建用户</el-button>
            <el-select v-model="state" placeholder="Select" style="width: 6em; margin-left: 8px;" @change="getPage">
              <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; padding-bottom: 12px;"
              v-loading="loading"
              size="default"
          >
<!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="account" label="账号" v-if="checkColList.indexOf('账号') > -1"/>
            <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1"/>
            <el-table-column property="" label="超级管理员" v-if="checkColList.indexOf('超级管理员') > -1">
              <template #default="scope">
                <p>{{scope.row.isSuper == 1?'是':'否'}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="可见时间" v-if="checkColList.indexOf('可见时间') > -1">
              <template #default="scope">
                <p>{{scope.row.duration == 0?'不限':scope.row.duration + '个月'}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p>{{scope.row.state == 0?'正常':scope.row.state == 1?'已停用':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-button @click="editUserDialog(scope.$index,scope.row)" type="text">编辑</el-button>
                <el-button @click="editUserModelDialog(scope.row)" type="text">权限</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData } from "@/api/api";
import {menuListAll, userListAll} from "@/api/url";
import SysAdminDialog from "./components/SysAdminDialog";
import UserModelDialog from "./components/UserModelDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'

export default {
  name: "SysAdmin",
  components: { BtnGroup },
  data() {
     return {
       pageDataList: [],
       loading: false,

       stateArray: [
         {label: '不限', value: -1},
         {label: '正常', value: 0},
         {label: '停用', value: 1}
       ],

       state: 0,

       //刷新组
       colList: ['创建时间', '账号', '名称', '超级管理员', '可见时间','状态', '操作'],
       checkColList: [],

       powerList: [],

     }
  },
  methods: {

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    getPage() {
      this.loading = true
      let param = {};
      param['state'] = this.state;
      getFormData(userListAll, param).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          this.pageDataList = data.data
          this.pageDataList.forEach((item)=> {
            item.createTime = this.formatTime(item.createTime)
            item.updateTime = this.formatTime(item.updateTime)
          })
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 1000,
          })
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message({
          message: err.msg,
          type: 'warning',
          duration: 1000
        })
      })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editUserDialog(idx, row) {
      let _title = '';
      let userForm = {}
      if (idx > -1) {
        _title = '编辑用户'
        userForm = Object.assign({}, row);
        // console.log(userForm)
      }else {
        _title = '创建用户'
        console.log(userForm)
      }
      Dialog.open({
        title: _title,
        component: SysAdminDialog,
        data: {
          userForm: userForm,
          ids: idx,
          width: '500px',
        },
        confirm: (result) => {
          if(idx > -1) {
            this.pageDataList[idx]['account'] = result['account']
            this.pageDataList[idx]['name'] = result['name']
            this.pageDataList[idx]['isSuper'] = result['isSuper']
            this.pageDataList[idx]['state'] = result['state']
            this.pageDataList[idx]['phoneViewNum'] = result['phoneViewNum']
            this.pageDataList[idx]['idnoViewNum'] = result['idnoViewNum']
            this.pageDataList[idx]['wechatViewNum'] = result['wechatViewNum']
            this.pageDataList[idx]['idnoImgViewNum'] = result['idnoImgViewNum']
          }else{
            this.getPage()
          }
        }
      })
    },

    editUserModelDialog(row) {
      let _title = row.account + ' 的权限'
      console.log(_title)
      let userModelForm = Object.assign({},row)
      Dialog.open({
        title: _title,
        component: UserModelDialog,
        data: {
          userModelForm: userModelForm,
          powerList: this.powerList,
          width: '700px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getMenuList() {
      getFormData(menuListAll, {}).then((data) => {
        this.powerList = data.data;
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getMenuList()
  }
}
</script>

<style scoped>
.el-table {
  --el-table-header-bg-color: #ffffff !important;
}
</style>
